var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading2)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e(),(!_vm.loading)?_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data2.contacts}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }